import useDeposit from '@app/features/payment/hooks/useDeposit';
import useDepositTransactions from '@app/features/payment/hooks/useTransactions';

import DepositTransactionItem from '../DepositTransactionItem';

import './DepositTransactionList.scss';

function DepositTransactionList() {
  const deposit = useDeposit();
  const { data: transactions } = useDepositTransactions(deposit.data?.id ?? null);

  return (
    <div className="space-2x">
      <table className="ResponsiveTable">
        <thead className="ResponsiveTable__heading-group align-left">
          <tr>
            <th className="ResponsiveTable__heading-cell">
              <p className="ResponsiveTable__heading-cell-text">
                <b>일시</b>
              </p>
            </th>
            <th className="ResponsiveTable__heading-cell">
              <p className="ResponsiveTable__heading-cell-text">
                <b>내용</b>
              </p>
            </th>
            <th className="ResponsiveTable__heading-cell align-right">
              <p className="ResponsiveTable__heading-cell-text">
                <b>금액 / 잔액</b>
              </p>
            </th>
            <th className="ResponsiveTable__heading-cell align-right">
              <p className="ResponsiveTable__heading-cell-text">
                <b>비고</b>
              </p>
            </th>
          </tr>
        </thead>
        <tbody>
          {transactions &&
            transactions.length > 0 &&
            transactions.map((item) => (
              <DepositTransactionItem
                balance={item.balance}
                change={item.change}
                content={item.content}
                description={item.description || ''}
                key={item.id}
                timestamp={item.timestamp}
              />
            ))}
        </tbody>
      </table>
      {transactions && transactions.length === 0 && (
        <div
          className="DepositTransactionList__no-list-message"
          data-testid="empty-deposit-transactions"
        >
          <h5>아직 예치금으로 충전 또는 결제한 내역이 없습니다.</h5>
        </div>
      )}
    </div>
  );
}

export default DepositTransactionList;
